module.exports = __webpack_public_path__ + "5c114213/img/cadBim.e369a02a.png";